import { useState } from "react";
import { IconButton } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { ButtonContainer } from "../KeywordsQueryBarStyles";
import { KeywordsGroupEditorModal } from "app/pages/keyword-analysis/KeywordsGroupEditorModal";
import { FilterChangedNotification } from "pro-features/components/tooltips/src/DMIFilterTooltip/FilterEducationTooltip";
import { EFilterChangedTooltipTypes } from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltipTypes";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { noop } from "lodash";
import { PlainTooltip } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { AUTO_CERATE_KEYWORD_LIST } from "../constants";
import type { IKeywordGroup } from "app/common/keyword-research/monitor-lists/monitorKeywordsTypes";
import { useDispatch } from "react-redux";
import { showSuccessToast } from "app/actions/toast_actions";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useCurrentStateAndParams } from "@uirouter/react";
import { allTrackers } from "app/services/track/track";

const preferenceKey = "keywords-query-bar-create-new-group-intro-tooltip-hidden";

export const CreateNewGroupButton = ({
    keyword,
    showCompactButton,
}: {
    keyword: string;
    showCompactButton: boolean;
}) => {
    const { state } = useCurrentStateAndParams();
    const translate = useTranslation();
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const openKeywordGroupCreationModal = () => {
        setIsOpen(true);
        allTrackers.dispatchTrackEvent("Button", "click", "Auto Create KW Lists CTA clicked/Magic Wand");
    };

    const iconButton = (
        <ButtonContainer>
            <IconButton
                iconName="wand"
                type={showCompactButton ? "flat" : "outlined"}
                onClick={openKeywordGroupCreationModal}
            >
                {showCompactButton ? undefined : translate("keywordanalysis.querybar.auto.create")}
            </IconButton>
        </ButtonContainer>
    );

    const showListCreatedSuccessfullyToast = (savedList: IKeywordGroup) => {
        dispatch(showSuccessToast(translate("create.list.wizard.toast", { listName: savedList.Name })));
    };

    const refreshPageWithSavedList = (savedList: IKeywordGroup) => {
        proNavigator.go(
            state.name,
            {
                keyword: `*${savedList.Id}`,
            },
            { reload: true },
        );
    };

    const onSavedList = (savedList: IKeywordGroup) => {
        showListCreatedSuccessfullyToast(savedList);
        refreshPageWithSavedList(savedList);
    };

    return (
        <>
            <FilterChangedNotification
                preferencesKey={preferenceKey}
                firstTooltipTitle={translate("keywordanalysis.querybar.auto.create.introduction")}
                tooltipTitle={translate("keywordanalysis.querybar.auto.create.introduction")}
                firstTooltipBody={translate("keywordanalysis.querybar.auto.create.introduction.body")}
                tooltipBody={translate("keywordanalysis.querybar.auto.create.introduction.body")}
                filterType={EFilterChangedTooltipTypes.COUNTRY_PICKER}
                onTooltipVisible={() => PreferencesService.add({ [preferenceKey]: true })}
                onClose={noop}
                childComponent={(_, __, isNotificationPresent) =>
                    isNotificationPresent ? (
                        iconButton
                    ) : (
                        <PlainTooltip
                            placement="bottom"
                            tooltipContent={i18nFilter()(AUTO_CERATE_KEYWORD_LIST)}
                        >
                            {iconButton}
                        </PlainTooltip>
                    )
                }
            />
            <KeywordsGroupEditorModal
                onClose={() => {
                    setIsOpen(false);
                }}
                open={isOpen}
                seedKeyword={keyword}
                onSave={onSavedList}
            />
        </>
    );
};
